import { useEffect, useState } from "react";
import { RotateCcw, Trash2, Building2, Users, BriefcaseBusiness, WalletCards } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "../api";
import { useAuth } from "../auth";

const KINDS = [
  { key: "projects", label: "Projeler", icon: BriefcaseBusiness },
  { key: "employers", label: "İşverenler", icon: Building2 },
  { key: "subcontractors", label: "Alt Yükleniciler", icon: Users },
  { key: "payments", label: "Ödemeler", icon: WalletCards },
];

const title = (kind, d) => {
  if (kind === "projects") return d.name;
  if (kind === "payments") return `${d.stage || "Ödeme"} · ${money(d.amount, d.currency)}`;
  return d.short_name || d.name;
};
const sub = (kind, d) => {
  if (kind === "projects") return `#${d.project_no || "-"} · ${d.employer_short || "—"}`;
  if (kind === "payments") return `${d.project_name || "—"} · ${d.direction === "incoming" ? "Tahsilat" : "Ödeme"}`;
  return d.name || "";
};

export default function Trash() {
  const { can } = useAuth();
  const isAdmin = can("admin");
  const [data, setData] = useState(null);

  const load = () => api.get("/trash").then((r) => setData(r.data)).catch(() => toast.error("Çöp kutusu yüklenemedi"));
  useEffect(() => { load(); }, []);

  const restore = async (kind, id) => {
    try { await api.post(`/trash/${kind}/${id}/restore`); toast.success("Kayıt geri yüklendi"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const purge = async (kind, id) => {
    if (!window.confirm("Bu kayıt KALICI olarak silinecek ve geri alınamayacak. Emin misiniz?")) return;
    try { await api.delete(`/trash/${kind}/${id}`); toast.success("Kalıcı olarak silindi"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  if (!data) return <main className="content"><p>Yükleniyor…</p></main>;
  const totalCount = KINDS.reduce((s, k) => s + (data.counts?.[k.key] || 0), 0);

  return (
    <main className="content" data-testid="page-trash">
      <div className="page-head">
        <div>
          <span className="section-kicker">GERİ ALINABİLİR SİLME</span>
          <h1>Çöp Kutusu ({totalCount})</h1>
          <p>Silinen kayıtlar burada saklanır. Geri yükleyebilir veya kalıcı olarak silebilirsiniz.</p>
        </div>
      </div>

      {totalCount === 0 && <div className="empty-hint" data-testid="trash-empty">Çöp kutusu boş. Silinen projeler, işverenler, alt yükleniciler ve ödemeler burada görünür.</div>}

      {KINDS.map(({ key, label, icon: Icon }) => {
        const items = data[key] || [];
        if (!items.length) return null;
        return (
          <section className="panel" key={key} data-testid={`trash-section-${key}`}>
            <div className="panel-head">
              <div><span className="eyebrow"><Icon size={12} style={{ verticalAlign: "-2px", marginRight: 4 }} />{label.toUpperCase()}</span><h2>{items.length} kayıt</h2></div>
            </div>
            <div className="project-table">
              {items.map((d, i) => (
                <div className="table-row trash-row" key={d.id} data-testid={`trash-row-${key}-${i}`}>
                  <div><b className="text-line">{title(key, d)}</b><small className="text-line">{sub(key, d)}</small></div>
                  <small className="muted-cell">{d.deleted_at ? `Silindi: ${d.deleted_at.slice(0, 10)}` : ""}</small>
                  <div className="row-actions">
                    <button className="import-btn sm" onClick={() => restore(key, d.id)} data-testid={`trash-restore-${key}-${i}`}><RotateCcw size={13} /> Geri Yükle</button>
                    {isAdmin && <button className="row-action danger" onClick={() => purge(key, d.id)} data-testid={`trash-purge-${key}-${i}`}><Trash2 size={13} /></button>}
                  </div>
                </div>
              ))}
            </div>
          </section>
        );
      })}
    </main>
  );
}
